import { Component, OnInit, ViewChild } from '@angular/core';
import { GridColumnMasterAPIModel } from './grid-column-master';
import * as ngswal from "sweetalert";
import { ApiMethod } from '../../apimethods/api-method';
import { Router } from '@angular/router';
import { GlobalConstants } from '../../common/global-constants';
import { customfunctions, DataParam } from '../../common/customfunctions';
declare var $;

@Component({
  selector: 'app-grid-column-master',
  templateUrl: './grid-column-master.component.html',
  styleUrls: ['./grid-column-master.component.css']
})
/** GridColumnMaster component*/
export class GridColumnMasterComponent implements OnInit {
  modelItem = new GridColumnMasterAPIModel();
  Popuptitle: any;
  GroupbyActivity: any;
  GridTranslist: any;
  GetColumndatatype: any;
  GetAlingment: any;
  GetPublisherList: any;
  // data table
  @ViewChild('dataTable', { static: false }) table: { nativeElement: any; }
  dataSet: string;
  dataTable: any;
  popupButtonText: string;
  GetGroupbyAction: any;

  ngOnInit(): void {
    ApiMethod.getBaseUrl();
  }
  /** GridColumnMaster ctor */
  constructor(private router: Router) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <GridColumnMasterAPIModel>data["GridColumnMasterPage"];

        $("#ddlActionitem").select2({
          placeholder: "Select Actionitem", dropdownParent: "#divGridmastertab"
        }); $("#ddlActionitem").val([]).trigger("change");

        $("#ddlColumndatatype").select2({
          placeholder: "Select Columndatatype", dropdownParent: "#divGridTrans"
        }); $("#ddlColumndatatype").val([]).trigger("change");

        $("#ddlPublisherList").select2({
          placeholder: "Select Publisher", dropdownParent: "#divGridmastertab"
        }); $("#ddlPublisherList").val([]).trigger("change");

        $("#ddlAlignment").select2({
          placeholder: "Select Alignment", dropdownParent: "#divGridTrans"
        }); $("#ddlAlignment").val([]).trigger("change");

        this.GetGroupbyActionitem();
        this.GetGridcolumndata();

      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  //Get GroupbyActionitem list
  GetGroupbyActionitem(): void {
    ApiMethod.getMethod(this.modelItem.GetGroupbydetails).subscribe(
      result => {
        this.GetGroupbyAction = result.aGetActionitem;
        this.GetPublisherList = result.aPublisherList;

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      }
    );
  }

//Get Main GridColumn Table
  GetGridcolumndata() {
    var publisherData = {
      PublisherId: localStorage.aPubID,
      LoginId: localStorage.aLoginID,
      ModuleName: "GridColumnModule"
    };

    ApiMethod.postMethod(this.modelItem.GetGridcolumndata, publisherData).subscribe(
      Response => {

        this.dataSet = JSON.stringify(Response.aGridMasterdata); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let aColList = Response.gridColumnList; // grid column data
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 150);
        dataItem.modulename = 'GridColumnModule';
        dataItem.aNewButtonName = 'BtnPopup';
        dataItem.isDefault = false;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

//hide popup
  hide() {
    this.GetGridcolumndata();
    $('#btnPopupGridDetails').hide();
  }

// clear Field
  clear() {
    //text
    $('#Txt_GridName').val('');
    $('#Txt_ModuleName').val('');
    $('#Txt_TableName').val('');
    $('#Txt_DU_IconViewStatus').val('');
    $('#Txt_Remarks').val('');
    //checkbox 
    $('#Txt_ExportExcel').prop("checked", false);
    $('#Txt_ExportPDF').prop("checked", false);
    $('#Txt_ExportCSV').prop("checked", false);
    $('#Txt_ExportWord').prop("checked", false);
    $('#Txt_ExportWord').prop("checked", false);
    //dropdown
    $('#ddlPublisherList').val(0).change();
    $('#ddlActionitem').val(0).change();
    //table body clear
    $("#tblcolumtans tbody tr").html("");
  }

//Get Popup Gridcolumn details
  getpopupdetails() {
    this.clear();
    $('#btnPopupGridDetails').show();

    if (localStorage.aEID != 0) {
      $("#LoadingImageReopen").show();

    
      $('.tblcolumtans').css('height', GlobalConstants.size.height - 220);
      $('#popupbody').css('height', GlobalConstants.size.height - 25);

      ApiMethod.getMethod(this.modelItem.GetGriddeailsAPI + "/" + localStorage.aEID).subscribe(
        Response => {
          var GridColumn = Response.aGridColumndata;
          this.GridTranslist = GridColumn;
          //popup title
          this.Popuptitle = "ModuleName  :" + " " + GridColumn[0].ModuleName;

          $('#Txt_GridName').val(GridColumn[0].GridName);
          $('#Txt_ModuleName').val(GridColumn[0].ModuleName);
          $('#ddlPublisherList').val(GridColumn[0].PublisherID).change();
          $('#Txt_TableName').val(GridColumn[0].TableName);
          $('#Txt_DU_IconViewStatus').val(GridColumn[0].DU_IconViewStatus);
          $('#Txt_Remarks').val(GridColumn[0].Remarks);
          $('#Txt_ExportExcel').prop("checked", GridColumn[0].ExportExcel);
          $('#Txt_ExportPDF').prop("checked", GridColumn[0].ExportPDF);
          $('#Txt_ExportCSV').prop("checked", GridColumn[0].ExportCSV);
          $('#Txt_ExportWord').prop("checked", GridColumn[0].ExportWord);
          $("#ddlActionitem").val(GridColumn[0].ActionsItems).change();

          $("#LoadingImageReopen").hide();
        }, error => {
          $("#LoadingImageReopen").hide();
          ngswal("Failed !", error.message, "error");
        });
      this.popupButtonText = " Update";
    } else {
      this.popupButtonText = "Add";
      this.Popuptitle = "Add New GridColumn Details";
    }
  }

  // Add New row in Table
  addNewRow() {
    if (this.validate()) {
      //Get Table Row count
      let trcount = $('#tblcolumtans tbody tr').length + 1;
      // Getlast row displayorder value
      let lastdisplayNo = $('#tblcolumtans tbody tr:last-child').find('#txt_displayorder').val();
      let lastdisplayNoNum = parseInt(lastdisplayNo) + 1;

      var nRowL = "<tr id=tr" + trcount + ">";
      nRowL += '<td>' + trcount + '</td>';
      nRowL += '<td style="display:none"></td>';
      nRowL += '<td><input type="text" id="txt_columndata"class="form-control"/></td>';
      nRowL += '<td><input type="text"id="txt_ColumnTitle" class="form-control"/></td>';
      nRowL += '<td><input type="text"id="txt_ColumnDataType" class="form-control"/></td>';
      nRowL += '<td><input type="text" id="txt_ColumnReturnData" class="form-control"/></td>';
      nRowL += '<td align="center"><input type="checkbox" id="bool_sortable" name="ToSmart" /></td>';
      nRowL += '<td><input type="text"id="txt_Alignment" class="form-control"/></td>';
      nRowL += '<td><input type="number" title="center,left,right" class="form-control IsNumeric" min="0" max="1" id="txt_Actions" style="width:70px;align:center" /></td>';
      nRowL += '<td><input type="number" value="' + lastdisplayNoNum + '" id="txt_displayorder" class="form-control IsNumeric" style="width:70px;align:center" /></td>';
      nRowL += '<td align="center"><input type="checkbox" id="bool_visible" /></td>';
      nRowL += '<td align="center"><input type="checkbox" id="bool_isdelete" /></td>';
      nRowL += "</tr>";

      $('#tblcolumtans tbody').append(nRowL);
    }
  }
  // Delete last row of table
  deletelastrow() {
    $("#tblcolumtans tbody tr:last").remove();
  }
  // update Gridcolumn Master
  updateFieldDetails() {
    var isValid = this.validate();
    if (!isValid) {
      return false;
    }
    if (isValid) {
      if ($("#tblcolumtans tbody tr").html() == null || $("#tblcolumtans tbody tr").html() == "") {
        ngswal("Warning !", "Add GridcolumnTrans !", "warning");
        isValid = false;
        return false;
      }
    }
    $("#LoadingImageReopen").show();
    var getGridColumdata = GlobalConstants.GetTableRowToList('tblcolumtans', null);
    var dataItem = {
      GridID: localStorage.aEID,
      GridName: $('#Txt_GridName').val(),
      ModuleName: $('#Txt_ModuleName').val(),
      TableName: $('#Txt_TableName').val(),
      ExportExcel: $('#Txt_ExportExcel').prop('checked'),
      ExportPDF: $('#Txt_ExportPDF').prop('checked'),
      ExportCSV: $('#Txt_ExportCSV').prop('checked'),
      ExportWord: $('#Txt_ExportWord').prop('checked'),
      DU_IconViewStatus: $('#Txt_DU_IconViewStatus').val(),
      Remarks: $('#Txt_Remarks').val(),
      PublisherID: $('#ddlPublisherList').val(),
      ActionsItems: $('#ddlActionitem').val(),

      FieldList: JSON.stringify(getGridColumdata)
    };
    ApiMethod.postMethod(this.modelItem.GetGridcolumndataApi, dataItem).subscribe(
      Response => {
        if (Response.zResultL == "Success") {
          $('#btnPopupGridDetails').hide  ();
          this.GetGridcolumndata();
          $("#LoadingImageReopen").hide();
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Updated !",
            text: " Updated Successfully",
            showConfirmButton: false,
            timer: 1500
          });

        } else {
          $("#LoadingImageReopen").hide();
          ngswal({
            position: 'top-end',
            type: "error",
            title: "Updated Failed!",
            text: " Data Not Added",
            showConfirmButton: false,
            timer: 1500
          });
        }
      },

      error => {
        ngswal("Failed !", error.error.Message, "warning");
        $("#LoadingImageReopen").hide();
      }
    );
  }

  //Validation
  validate() {
    var aResultL = true;
    if ($('#Txt_GridName').val() == "") {
      ngswal("Warning !", "Enter GridName ", "warning");
      aResultL = false;
    } else if ($('#Txt_ModuleName').val() == "") {
      ngswal("Warning !", "Enter ModuleName ", "warning");
      aResultL = false;
    } else if ($('#ddlPublisherList').val() == 0) {
      ngswal("Warning !", "Choose Publisher ", "warning");
      aResultL = false;
    } else if ($('#Txt_TableName').val() == "") {
      ngswal("Warning !", "Enter TableName ", "warning");
      aResultL = false;
    } else if ($('#ddlActionitem').val() == "null") {
      ngswal("Warning !", "Enter TableName ", "warning");
      aResultL = false;
    }
    $("#tblcolumtans tbody").each(function () {
      $(this).children().each(function (index) {

        if ($(this).find('#txt_columndata').length > 0 && $(this).find('#txt_columndata').val() === "") {
          ngswal("Warning !", "Enter columndata !", "warning");
          aResultL = false;
        } else if ($(this).find('#txt_ColumnTitle').length > 0 && $(this).find('#txt_ColumnTitle').val() === "") {
          ngswal("Warning !", "Enter ColumnTitle !", "warning");
          aResultL = false;
        } else if ($(this).find('#txt_ColumnDataType').length > 0 && $(this).find('#txt_ColumnDataType').val() === "") {
          ngswal("Warning !", "Enter ColumnDataType !", "warning");
          aResultL = false;
        } else if ($(this).find('#txt_Alignment').length > 0 && $(this).find('#txt_Alignment').val() === "") {
          ngswal("Warning !", "Enter Alignment !", "warning");
          aResultL = false;
        }
        else if ($(this).find('#txt_Actions').val() === "") {
          ngswal("Warning !", "Enter Actions !", "warning");
          aResultL = false;
        }
        else if ($(this).find('#txt_displayorder').length > 0 && $(this).find('#txt_displayorder').val() === "0") {
          ngswal("Warning !", "Enter Displayorder !", "warning");
          aResultL = false;
        }
      });
    });

    return aResultL;
  }
}
